// removed by extract-text-webpack-plugin
module.exports = {"featuresIcons":"lVbWwQHjznqMYiqsM6teE","iconContainer":"_1FCPLXoYcamLuotUihKrO-","highlighted":"_300uLpNSYN8HONphNm-NE2","title":"_3KLC3k7Gk3RxFpNR8JRqyO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeaturesIcons/FeaturesIcons.scss
// module id = 1596
// module chunks = 0